import axios, { AxiosRequestConfig } from "axios";
import { httpService } from "../http";
import { Data } from "../service";
import { IDonationInfo, ParticipationResult, ParticipationSearchParams, WelfareBannerType, WelfareDetailType, WelfareExchangeType, WelfareItemsType, WelfareType, WelfareVosType } from "./welfare";

const GO_MICRO = process.env.REACT_APP_GO_MICRO
const REACT_APP_MIO_SASS = process.env.REACT_APP_MIO_SASS

export const GetRidAuth = async () => {
  const { loginUrl } = await httpService.get("/mp2c-micro/user/miowelfare/login", {}, { baseURL: GO_MICRO }) as unknown as { loginUrl: string }
  return (await axios.get(loginUrl as string)).data?.data
}

/**
 *公益项目Banner
 * @returns
 */
export const GetWelfareBanner = async (rid: string): Promise<WelfareBannerType[]> => {
  return httpService.get(`/welfare/spu/public-welfare/banner`, {}, { baseURL: REACT_APP_MIO_SASS });
}
/**
 * 公益项目分类
 * @param param
 * @returns
 */
export const GetWelfareCategory = async (rid: string): Promise<WelfareType[]> => {
  return httpService.get(`/welfare/spu/public-welfare/category`, {}, { baseURL: REACT_APP_MIO_SASS });
}

/**
 * @access 公益项目分类列表
 */
export const GetWelfareList = async (rid: string, param: { pageNum: string, pageSize: string, categoryId: string }): Promise<Data<WelfareItemsType>> => {
  return httpService.get(`/welfare/spu/public-welfare/list`, param, { baseURL: REACT_APP_MIO_SASS });
}
/**
 * 兑换证书
 * @param param
 * @returns
 */
export const postExchange = async (rid: string, param: { skuId: string }): Promise<string> => {
  return httpService.post(`/welfare/spu/public-welfare/certificate/exchange`, param, { baseURL: REACT_APP_MIO_SASS });
}
/**
 * 获取项目详情
 * @param param
 * @returns
 */
export const getWelfareDetail = async (rid: string, param: { skuId: string }): Promise<WelfareDetailType> => {
  return httpService.get(`/welfare/spu/public-welfare/detail`, param, { baseURL: REACT_APP_MIO_SASS });
}
/**
 * 获取剩余积分
 * @param rid 
 * @param param 
 * @returns 
 */
export const getResidualIntegral = async (rid: string): Promise<string> => {
  return httpService.get(`/welfare/spu/public-welfare/point/balance`, {}, { baseURL: REACT_APP_MIO_SASS });
}
/**
 * 项目参与列表
 * @param rid 
 * @param param 
 * @returns 
 */
export const getWelfareParticipation = async (rid: string, param: { skuId: string }): Promise<WelfareVosType> => {
  return httpService.get(`/welfare/spu/public-welfare/participation`, param, { baseURL: REACT_APP_MIO_SASS });
}
/**
 * 获取个人证书列表
 * @param rid 
 * @param param 
 * @returns 
 */
export const getIndividualList = async (rid: string): Promise<WelfareExchangeType[]> => {
  return httpService.get(`/welfare/spu/public-welfare/certificate/individual/record`, {}, { baseURL: REACT_APP_MIO_SASS });
}

/**
 * 获取项目捐赠证明
 * @param spuId 
 * @param param 
 * @returns 
 */
export const getProjectDonationInfo = async (spuId: string): Promise<IDonationInfo> => {
  return httpService.get(`/welfare/donation-certifications/${spuId}`, {} , { baseURL: REACT_APP_MIO_SASS });
}

/**
 * 获取参与记录上链信息
 * @param spuId 
 * @param param 
 * @returns 
 */
export const getParticipationDonationInfo = async (id: string, rid: string): Promise<IDonationInfo> => {
  return httpService.get(`/welfare/spu/public-welfare/participation/${id}`, {  }, { 
    headers: { system: 'H5' },
    baseURL: REACT_APP_MIO_SASS,
   } as AxiosRequestConfig);
}

/**
 * 获取参与记录列表
 * @param spuId 
 * @param param 
 * @returns 
 */
export const getParticipationRecord = async (params: ParticipationSearchParams): Promise<ParticipationResult> => {
  return httpService.get(`/welfare/donation-certifications/record`, params, { 
    headers: { system: 'H5' },
    baseURL: REACT_APP_MIO_SASS,
   } as AxiosRequestConfig);
}
/**
 * 我的证书v2 证书列表（绿喵证书+绿色住证书）
 * @param params 
 * @returns 
 */
export const getCertificateList = async (): Promise<{list:WelfareExchangeType[]}> => {
  return httpService.get(`/mp2c-micro/user/certificate/page`, {}, { baseURL: GO_MICRO } as AxiosRequestConfig);
}

